import { styled } from "theme/default/styled";
import { setFlexDFFDC } from "theme/setter/setFlexValues/setFlexDFFDC";

export const SRefundDetailsPageContent = styled.div`
  ${setFlexDFFDC};
`;
